var map = {
	"./photo1.jpg": "1a8e",
	"./photo10.jpg": "d1d0",
	"./photo11.jpg": "0a71",
	"./photo12.jpg": "6745",
	"./photo13.jpg": "c044",
	"./photo14.jpg": "bf71",
	"./photo15.jpg": "8178",
	"./photo16.jpg": "c57a",
	"./photo2.jpg": "e700",
	"./photo3.jpg": "2a00",
	"./photo4.jpg": "6e8c",
	"./photo5.jpg": "dc86",
	"./photo6.jpg": "dc6a",
	"./photo7.jpg": "972b",
	"./photo8.jpg": "aa6e",
	"./photo9.jpg": "55aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3280";